import { useState, useCallback } from "react";
import DataPicker from "../components/DataPicker";
import PortalPopup from "../components/PortalPopup";
import CTAs from "../components/CTAs";

const DateFilter = ({ onClose, onDateTimeSelect }) => {
  const [isDataPickerOpen, setDataPickerOpen] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(() => {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() + 7);
    return {
      startDate: today.toLocaleDateString("en-GB"),
      endDate: sevenDaysAgo.toLocaleDateString("en-GB"),
    };
  });
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [fromDropdownOpen, setFromDropdownOpen] = useState(false);
  const [toDropdownOpen, setToDropdownOpen] = useState(false);

  const timeOptions = Array.from(
    { length: 24 },
    (_, i) => `${i.toString().padStart(2, "0")}:00`,
  );

  const handleDateSelect = (dateRange) => {
    setSelectedDateRange(dateRange);
    closeDataPicker();
  };

  const handleDateTimeApply = () => {
    onDateTimeSelect({
      startDate: selectedDateRange.startDate,
      endDate: selectedDateRange.endDate,
      fromTime,
      toTime,
    });
    onClose();
  };

  const openDataPicker = useCallback(() => setDataPickerOpen(true), []);
  const closeDataPicker = useCallback(() => setDataPickerOpen(false), []);

  return (
    <>
      <style>{`
        .dd-card {
          background: #ffffff; border: 1px solid #E2E8F0; border-radius: 16px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 2px 12px rgba(0,0,0,0.04);
          font-family: 'DM Sans', sans-serif;
        }
        .dd-input {
          width: 100%; padding: 12px 14px; border: 1px solid #E2E8F0; border-radius: 8px;
          background: #ffffff; outline: none; transition: border-color 0.15s;
          display: flex; align-items: center; justify-content: space-between; cursor: pointer;
        }
        .dd-input:focus-within { border-color: #2563EB; }
        .dd-dropdown {
          position: absolute; top: 100%; left: 0; width: 100%; max-height: 200px;
          overflow-y: auto; background: #ffffff; border: 1px solid #E2E8F0; border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08); margin-top: 4px; z-index: 10;
        }
        .dd-dropdown-item {
          padding: 10px 14px; cursor: pointer; font-size: 14px; color: #1E293B;
          transition: background 0.15s;
        }
        .dd-dropdown-item:hover { background: #F1F5F9; }
      `}</style>

      <div
        className="dd-card"
        style={{ width: "420px", display: "flex", flexDirection: "column" }}
      >
        <div
          style={{
            padding: "24px 24px 0",
            display: "flex",
            flexDirection: "column",
            gap: 24,
          }}
        >
          <div>
            <label className="dd-section-label">Dates</label>
            <div className="dd-input" onClick={openDataPicker}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <img src="assets/calendar.svg" alt="" style={{ width: 20 }} />
                <span style={{ fontSize: 14, color: "#1E293B" }}>
                  {selectedDateRange.startDate} - {selectedDateRange.endDate}
                </span>
              </div>
              <img src="assets/arrow-down.svg" alt="" style={{ width: 20 }} />
            </div>
          </div>

          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}
          >
            {/* From time */}
            <div style={{ position: "relative" }}>
              <label className="dd-section-label">From</label>
              <div
                className="dd-input"
                onClick={() => setFromDropdownOpen(!fromDropdownOpen)}
              >
                <span
                  style={{
                    fontSize: 14,
                    color: fromTime ? "#0F172A" : "#94A3B8",
                  }}
                >
                  {fromTime || "Select"}
                </span>
                <img src="assets/arrow-down.svg" alt="" style={{ width: 20 }} />
              </div>
              {fromDropdownOpen && (
                <div className="dd-dropdown">
                  {timeOptions.map((time) => (
                    <div
                      key={`from-${time}`}
                      className="dd-dropdown-item"
                      onClick={() => {
                        setFromTime(time);
                        setFromDropdownOpen(false);
                      }}
                    >
                      {time}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* To time */}
            <div style={{ position: "relative" }}>
              <label className="dd-section-label">To</label>
              <div
                className="dd-input"
                onClick={() => setToDropdownOpen(!toDropdownOpen)}
              >
                <span
                  style={{
                    fontSize: 14,
                    color: toTime ? "#0F172A" : "#94A3B8",
                  }}
                >
                  {toTime || "Select"}
                </span>
                <img src="assets/arrow-down.svg" alt="" style={{ width: 20 }} />
              </div>
              {toDropdownOpen && (
                <div className="dd-dropdown">
                  {timeOptions.map((time) => (
                    <div
                      key={`to-${time}`}
                      className="dd-dropdown-item"
                      onClick={() => {
                        setToTime(time);
                        setToDropdownOpen(false);
                      }}
                    >
                      {time}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: 12,
            padding: "24px",
            borderTop: "1px solid #E2E8F0",
            marginTop: 24,
          }}
        >
          <CTAs
            type="Secondarybtn"
            text="Cancel"
            width="50%"
            onClick={onClose}
          />
          <CTAs
            type="Primarybtn"
            text="Apply"
            width="50%"
            onClick={handleDateTimeApply}
          />
        </div>
      </div>

      {isDataPickerOpen && (
        <PortalPopup
          overlayColor="rgba(113,113,113,0.3)"
          placement="Centered"
          onOutsideClick={closeDataPicker}
        >
          <DataPicker
            onClose={closeDataPicker}
            onDateSelect={handleDateSelect}
          />
        </PortalPopup>
      )}
    </>
  );
};

export default DateFilter;
